import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, MenuItem, Select, FormControl, InputLabel, ListItem, Icon, ListItemText } from "@mui/material";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

function RelatedDropDown({ formRef, draftIndex, displayName, fieldRef, parentRef, options }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [parentValue, setParentValue] = useState(null);
  const [opts, setOpts] = useState([]);

  function initListener() {
    console.log(parentRef);
    const parentField = document.getElementById(`dff_${parentRef}`);
    if (parentField === null) {
      console.log("NULLESTTTT");
      return;
    }
    parentField.addEventListener("change", () => {
      setParentValue(parentField.value);
    });
  }

  useEffect(() => {
    initListener();
  }, []);

  useEffect(() => {
    setSelectedOption(null);
    if (parentValue === null) {
      setOpts([]);
      return;
    }

    let tempOpts = options[parentValue];
    if (typeof tempOpts === "undefined") {
      tempOpts = [];
    }
    setOpts(tempOpts);
  }, [parentValue]);

  useEffect(() => {
    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [selectedOption]);

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setDraftValue(val);
        setHasSavedValue(true);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <Box mt={4}>
      {hasSavedValue ? (
        <MDBox>
          <ListItem divider>
            <MDBox mr={1}>
              <Icon color="success">check_circle</Icon>
            </MDBox>
            <ListItemText
              primary={
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  {displayName}
                </MDTypography>
              }
              secondary={
                <MDTypography variant="body2" fontSize={13}>
                  {draftValue}
                </MDTypography>
              }
            />
            <MDButton
              size="small"
              color="warning"
              variant="outlined"
              iconOnly
              onClick={() => {
                try {
                  const key = `draft_${formRef}`;
                  const saved = localStorage.getItem(key);
                  if (!saved) return;

                  const parsed = JSON.parse(saved);

                  if (parsed?.values && fieldRef in parsed.values) {
                    delete parsed.values[fieldRef];
                  }

                  // persist updated draft
                  localStorage.setItem(key, JSON.stringify(parsed));

                  // update UI state
                  setHasSavedValue(false);
                  setDraftValue(null);
                } catch (e) {
                  console.error("Failed to clear draft field", e);
                }
              }}
            >
              <Icon>edit</Icon>
            </MDButton>
          </ListItem>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={draftValue}
          />
        </MDBox>
      ) : (
        <MDBox>
          <FormControl sx={{ minWidth: 120, width: "100%" }}>
            <InputLabel sx={{ whiteSpace: "break-spaces" }}>
              {displayName}
            </InputLabel>
            <Select
              // name={fieldRef}
              label={displayName}
              sx={{ padding: "12px", paddingLeft: "3px" }}
              onChange={(e) => {
                setSelectedOption(e.target.value);
              }}
              value={selectedOption}
            >
              {opts.map((option) => (
                <MenuItem value={option.value}>{option.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={selectedOption}
          />
        </MDBox>
      )}
    </Box>
  );
}

// Typechecking props of the Transaction
RelatedDropDown.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  parentRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

RelatedDropDown.defaultProps = {
  options: null,
};
export default RelatedDropDown;
